import {PointCoords} from '../@types';
import {convertToCoordFromPointCoords} from './coords';

interface Item {
  location: {
    coordinates: PointCoords;
  };
  position?: any;
  overlapped?: any[];
}

export const getOverlapedMarkers = (
  markers: any[],
  uniquKey: string | number = 'name'
) => {
  return markers.reduce((acc: any[], item: Item & {[key: string]: any}) => {
    const coords = item?.location?.coordinates;

    if (coords || item.position) {
      let isUnq = false;

      if (!item.position) {
        item.position = convertToCoordFromPointCoords(coords);
      }
      if (!item.overlapped) {
        item.overlapped = [];
      }

      if (!acc.length) {
        isUnq = true;
      } else {
        isUnq = !acc.some((base) => {
          const isEqPosition = item.position.equals(base.position);

          try {
            if (
              isEqPosition &&
              base[uniquKey] !== item[uniquKey] &&
              !base.overlapped.find(
                (i: Item & {[key: string]: any}) =>
                  i[uniquKey] === item[uniquKey]
              )
            ) {
              base.overlapped.push(item);
            }
          } catch (e) {
            console.log(e);
          }

          return isEqPosition;
        });
      }

      if (isUnq) {
        acc.push(item);
      }
    }

    return acc;
  }, []);
};

export const getHouseMarkerSize = (count?: number) => {
  if (count) {
    if (count >= 800) {
      return 15;
    }
    if (count >= 400) {
      return 13;
    }
    if (count >= 200) {
      return 11;
    }
    if (count >= 100) {
      return 9;
    }
    if (count >= 50) {
      return 7;
    }
  }
  return 5;
};
